import SharedPreferences from "../../../constants/SharedPreferences";
import { getFromStorage } from "../../../util/Utility";
import { aeadEncryptWithAssociatedData } from "../../../crypto/AuthenticatedEncryption";
import Constants from "../../../constants/Constants";
import { signOrgSettingsFromLastUpdatedAt, createInitialOrgSettingsLastUpdatedAt } from "../../../util/SignatureUtil";

export async function getOrgSettingsRequest(
  orgKey,
  orgName,
  _adminPrivateKey,
  sessionId,
) {
  // enterprise application
  let keyValidationPolicy = Constants.KEY_VALIDATION_POLICY.ORG_ADMIN_APPROVAL;
  let encryptionPolicy = Constants.DEFAULT_ENCRYPTION_POLICY;
  let memberApproval = Constants.EXPLICIT_MEMBER_APPROVAL;
  let appApproval = Constants.EXPLICIT_APP_APPROVAL;
  let keyGenerationPolicy = Constants.DEFAULT_KEY_GENERATION_POLICY;

  if (
    (process.env.SOURCE == Constants.SOURCE.BAYUN_ADMIN &&
      (await getFromStorage(
        sessionId,
        SharedPreferences.APPLICATION_TYPE,
      )) === Constants.APPLICATION_TYPE.CONSUMER) ||
    (await getFromStorage(sessionId, SharedPreferences.ORG_TYPE)) ===
    Constants.ORG_TYPE.CONSUMER
  ) {
    // consumer application
    keyValidationPolicy = Constants.DEFAULT_KEY_VALIDATION_POLICY;
    encryptionPolicy = Constants.MEMBER_ENCRYPTION_POLICY;
    memberApproval = Constants.DEFAULT_MEMBER_APPROVAL;
    appApproval = Constants.DEFAULT_APP_APPROVAL;
    keyGenerationPolicy = Constants.KEY_GENERATION_POLICY.CHAIN;
  }

  const plainSettings = {
    appApproval,
    encryptionMode: Constants.DEFAULT_ENCRYPTION_MODE,
    encryptionPolicy,
    encryptionStatus: Constants.DEFAULT_ENCRYPTION_STATUS,
    keyGenerationPolicy,
    keyValidationPolicy,
    lockboxExpiry: Constants.DEFAULT_LOCK_BOX_EXPIRY,
    minimumApprovalCount: Constants.DEFAULT_MINIMUM_APPROVAL_COUNT,
    statsSyncTime: Constants.DEFAULT_STATS_SYNC_TIME,
    memberApproval,
  };

  const settingLastUpdatedAt = Date.now();
  const orgSettingsLastUpdatedAt =
    createInitialOrgSettingsLastUpdatedAt(settingLastUpdatedAt);
  const adminSigningPrivateKey = await getFromStorage(
    sessionId,
    SharedPreferences.ADMIN_SIGNING_PRIVATE_KEY,
  );
  // The plaintext policy values must be inside the signature, not just the timestamps,
  // otherwise a server can swap them without invalidating it.
  const { signedSettings } = await signOrgSettingsFromLastUpdatedAt(
    orgSettingsLastUpdatedAt,
    adminSigningPrivateKey,
    sessionId,
    orgName,
    {
      keyValidationPolicy: plainSettings.keyValidationPolicy,
      memberApproval: plainSettings.memberApproval,
      appApproval: plainSettings.appApproval,
    },
  );

  return {
    encryptionMode: await aeadEncryptWithAssociatedData(
      plainSettings.encryptionMode,
      orgName,
      orgKey,
    ),
    encryptionPolicy: await aeadEncryptWithAssociatedData(
      plainSettings.encryptionPolicy,
      orgName,
      orgKey,
    ),
    encryptionStatus: await aeadEncryptWithAssociatedData(
      plainSettings.encryptionStatus,
      orgName,
      orgKey,
    ),
    keyGenerationPolicy: await aeadEncryptWithAssociatedData(
      plainSettings.keyGenerationPolicy,
      orgName,
      orgKey,
    ),
    lockboxExpiry: await aeadEncryptWithAssociatedData(
      plainSettings.lockboxExpiry,
      orgName,
      orgKey,
    ),
    minimumApprovalCount: await aeadEncryptWithAssociatedData(
      plainSettings.minimumApprovalCount,
      orgName,
      orgKey,
    ),
    signedSettings,
    settingLastUpdatedAt,
    statsSyncTime: await aeadEncryptWithAssociatedData(
      plainSettings.statsSyncTime,
      orgName,
      orgKey,
    ),
    memberApproval: plainSettings.memberApproval,
    appApproval: plainSettings.appApproval,
    keyValidationPolicy: plainSettings.keyValidationPolicy,
  };
}
